import { useCallback, useRef } from "react";

export function cleanseObject(data: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(data || {}).filter(([key, value]) => {
      if (value instanceof Date) {
        return !isNaN(value?.getTime());
      } else if (typeof value === "number") {
        return !isNaN(value);
      }
      return value !== undefined && value !== null && value !== "";
    })
  );
}

export function openInNewTab(url: string) {
  window?.open(url, "_blank")?.focus();
}

function forceDownload(blob: string, filename: string) {
  var a = document.createElement("a");
  a.download = filename;
  a.href = blob;
  a.click();
}

// Current blob size limit is around 500MB for browsers
export function downloadResource(url: string) {
  const filename = (url.split("\\").pop() || "").split("/").pop() || "";
  fetch(url, {
    headers: new Headers({ Origin: location.origin }),
    mode: "cors",
  })
    .then((response) => response.blob())
    .then((blob) => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch((e) => console.error(e));
}

export function capitalize(str: string) {
  str = str.trim();
  return `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
}

export function shorten(str: string, len = 90) {
  return str.length <= 90 ? str : str.slice(0, 87) + "...";
}

export function removeEmptyValues<X extends Record<string, unknown>>(obj: X) {
  return Object.fromEntries(Object.entries(obj).filter((e) => !!e[1])) as {
    [k in keyof X]: Exclude<X[k], null | undefined | "">;
  };
}

// debounce function
export const debounce = (func: any, delay: number) => {
  let timeoutId: any;
  return (...args: any) => {
      if (timeoutId) {
          clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
          func(...args);
      }, delay);
  };
};

export const useDebounce = (func: (...args: any) => void, delay: number) => {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  const debouncedFunction = useCallback((...args: any) => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      func(...args);
    }, delay);
  }, [func, delay]);

  return debouncedFunction;
};